import { render, staticRenderFns } from "./SingleOpeningApplicants.vue?vue&type=template&id=25afc351&"
import script from "./SingleOpeningApplicants.vue?vue&type=script&lang=js&"
export * from "./SingleOpeningApplicants.vue?vue&type=script&lang=js&"
import style0 from "./SingleOpeningApplicants.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports